import React from 'react';
import PropTypes from 'prop-types';

import SideMenu from './SideMenu';

// TODO: make clicking on blank space in SlideMenu not close menu
// .. can add stopPropagation() to wrapper.onClick. However, then clicking ChannelListItems will not close SlideMenu

const propTypes = {
    actions: PropTypes.array,
    visible: PropTypes.bool,
    hideMenu: PropTypes.func.isRequired,
    side: PropTypes.oneOf(['left', 'right']),
    channels: PropTypes.arrayOf(PropTypes.element),
    organizations: PropTypes.arrayOf(PropTypes.element)
};

const defaultProps = {
    actions: [],
    visible: true,
    side: 'left',
    channels: [],
    organizations: []
};

class SlideMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.updateScrollLock = this.updateScrollLock.bind(this);
    }

    componentDidMount() {
        const self = this;
        window.addEventListener('resize', self.updateScrollLock);
    }

    componentDidUpdate(prevProps, prevState) {
        // disallow scrolling when slide menu is visible
        // TODO: replace with non-jQuery alternative
        if (!prevProps.visible && this.props.visible) {
            $('html, body').addClass('lock-scroll-y');
        }
        else if (prevProps.visible && !this.props.visible) {
            $('html, body').removeClass('lock-scroll-y');
        }
    }

    componentWillUnmount() {
        const self = this;
        window.removeEventListener('resize', self.updateScrollLock);
    }

    updateScrollLock() {
        // if user widens/tightens their view and slide menu disappers/disappears due to css, ensure that scroll lock is updated
        // TODO: replace with non-jQuery alternative
        if ($('.slide-out-menu').is(':hidden')) {
            $('html, body').removeClass('lock-scroll-y');
        }
        else if ($('.slide-out-menu').is(':visible')) {
            $('html, body').addClass('lock-scroll-y');
        }
    }

    render() {
        return (
            <div className={`full-screen-blocker menu-blocker ${this.props.visible ? 'visible' : ''}`} onClick={this.props.hideMenu}>
                <div className={`slide-out-menu ${this.props.side} ${this.props.visible ? 'visible' : ''}`}>
                    <SideMenu
                    className="in-slide"
                    actions={this.props.actions}
                    channels={this.props.channels}
                    organizations={this.props.organizations}
                    />
                </div>
            </div>
        );
    }
}

SlideMenu.propTypes = propTypes;
SlideMenu.defaultProps = defaultProps;

export default SlideMenu;
